/* ============================================================
   COVVA · UPSELL PANIER (snippets/covva-cart-upsell.liquid)
   Délégation d'événements sur document : le tiroir est re-rendu par
   innerHTML (cart:refresh), les scripts qu'il contient ne sont pas
   relancés, donc ce fichier est chargé une seule fois hors du tiroir.
   Après ajout : uniquement cart:refresh (mécanisme du thème, tiroir via
   assets/app.js et page /cart via assets/cart.js). Pas de cart:item-added.
   Sous-total, remises et ligne pochette sont recalculés par Shopify.
   Idempotent : guard window.__covvaUpsellInit
   ============================================================ */
(function () {
  if (window.__covvaUpsellInit) return;
  window.__covvaUpsellInit = true;

  var addUrl = (window.theme && theme.routes && theme.routes.cart_add_url) || '/cart/add';

  document.addEventListener('change', function (event) {
    var select = event.target.closest && event.target.closest('[data-covva-upsell-select]');
    if (!select) return;
    var card = select.closest('.covva-upsell__card');
    var option = select.options[select.selectedIndex];
    var price = card && card.querySelector('[data-covva-upsell-price]');
    if (price && option && option.dataset.price) price.textContent = option.dataset.price;
  });

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-covva-upsell-add]');
    if (!button || button.disabled) return;
    event.preventDefault();

    var card = button.closest('.covva-upsell__card');
    var select = card && card.querySelector('[data-covva-upsell-select]');
    var error = card && card.querySelector('[data-covva-upsell-error]');
    var variantId = select ? select.value : button.dataset.variantId;
    if (!variantId) return;

    button.disabled = true;
    button.textContent = button.dataset.labelLoading;
    if (error) error.hidden = true;

    fetch(addUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        id: Number(variantId),
        quantity: 1,
        properties: { _source: 'cart_upsell' }
      })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('add failed');
        // Le re-rendu du panier remplace ce bloc : le bouton reste désactivé jusque-là.
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      })
      .catch(function () {
        button.disabled = false;
        button.textContent = button.dataset.label;
        if (error) error.hidden = false;
      });
  });
})();
